// extracted by mini-css-extract-plugin
export default {"container":"NotFoundView_container__uacla","content":"NotFoundView_content__129MR","footer":"NotFoundView_footer__vfbS9","clickable":"NotFoundView_clickable__d5XUm"};